import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';
import { apiFetch } from '../../utils/apiClient';

const AdminHome: React.FC = () => {
  const { t } = useTranslation();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    apiFetch('/api/admin/vendors/summary/')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setPending(d.pending || 0))
      .catch(() => undefined);
  }, []);

  const cards = [
    { to: '/admin/vendors', title: t('admin.vendors'), desc: t('admin.vendorsDesc'), badge: pending },
    { to: '/admin/orders', title: t('admin.orders'), desc: t('admin.ordersDesc') },
    { to: '/admin/categories', title: t('admin.categories'), desc: t('admin.categoriesDesc') },
    { to: '/admin/inventory', title: t('admin.inventory'), desc: t('admin.inventoryDesc') },
    { to: '/admin/sync-logs', title: t('admin.syncLogs'), desc: t('admin.syncLogsDesc') },
  ];

  return (
    <Layout>
      <div className="w-full">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">{t('admin.title')}</h1>
        {pending > 0 && (
          <Link to="/admin/vendors" className="block mb-4 rounded-lg border-2 border-orange-300 bg-orange-50 p-4 text-sm font-medium text-orange-900">
            {t('admin.pendingApprovals', { count: pending })} →
          </Link>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {cards.map((c) => (
            <Link key={c.to} to={c.to} className="bg-white shadow rounded-lg p-5 border border-gray-200 active:bg-gray-50 transition-colors">
              <div className="flex items-center justify-between">
                <div className="text-lg font-semibold text-gray-900">{c.title}</div>
                {c.badge ? <span className="min-w-[24px] h-6 px-2 rounded-full bg-blue-600 text-white text-xs font-semibold flex items-center justify-center">{c.badge}</span> : null}
              </div>
              <div className="text-sm text-gray-600 mt-1">{c.desc}</div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default AdminHome;
